import isAfter from './isAfter';
import isBefore from './isBefore';
import addDays from './addDays';
import isEqual from './isEqual';

export default function getDaysBetween(from: Date, to: Date): Date[] {
  if (isAfter(from, to)) {
    return [from];
  }
  let start = from;
  let result: Date[] = [];
  while (isBefore(start, to) || isEqual(start, to)) {
    result = [...result, start];
    start = addDays(start, 1);
  }
  return result;
}
